
import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../components/AuthContext';
import { SEO } from '../components/Shared';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const from = (location.state as any)?.from?.pathname || "/";

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      login(email);
      navigate(from, { replace: true });
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 arctic-bg">
      <SEO title="Kirjaudu | Lapland AI Lab" description="Arctic Command Login" />
      <div className="arctic-panel w-full max-w-md p-12 rounded-[3rem] border-white/10 shadow-2xl relative overflow-hidden">
        <div className="absolute -top-24 -right-24 w-48 h-48 bg-teal-400/10 rounded-full blur-3xl"></div>
        
        <div className="text-center mb-10">
          <div className="w-16 h-16 bg-gradient-to-br from-teal-300 to-purple-400 rounded-2xl mx-auto flex items-center justify-center mb-6 shadow-xl shadow-teal-500/20">
            <span className="text-white font-black text-2xl">L</span>
          </div>
          <h1 className="text-3xl font-black text-white tracking-tighter uppercase mb-2">Arctic Access</h1>
          <p className="text-slate-500 text-xs font-black uppercase tracking-widest">Organisaatioportaali</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest mb-2 ml-1">Sähköposti</label>
            <input 
              type="email" 
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="nimi@organisaatio.fi"
              className="w-full bg-slate-950 border border-white/10 rounded-2xl px-6 py-4 text-white focus:outline-none focus:border-teal-400/50 transition-all"
            />
          </div>
          <button 
            type="submit"
            className="w-full btn-primary font-black py-5 rounded-2xl uppercase tracking-widest hover:scale-[1.02] transition-transform"
          >
            Kirjaudu sisään
          </button>
        </form>

        <div className="mt-8 pt-8 border-t border-white/10 text-center">
          <p className="text-[10px] text-slate-600 font-bold uppercase tracking-widest">
            Vain valtuutetuille käyttäjille
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
